// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Bulma Utilities */\n@media screen and (min-width: 769px) {\na[href*=\"tel:\"][data-v-0445aabc] {\n    cursor: default;\n    pointer-events: none;\n    color: hsl(0deg, 0%, 29%);\n}\n}\n.contact-details[data-v-0445aabc] {\n  width: 100%;\n  min-width: 350px;\n}\n.user-details[data-v-0445aabc] {\n  font-size: 0.9rem;\n}\na[data-v-0445aabc] {\n  color: rgb(0, 0, 0);\n}\na[data-v-0445aabc]:hover {\n  color: rgb(214, 23, 112);\n}", ""]);
// Exports
module.exports = exports;
